import { fmtTimestamp } from "../../lib/dom.js";
import type { WhatsappChat, WhatsappMessage } from "../../types.ts";
import { effectiveMessageKind, persistedOutgoingAckStatus, senderColorFor } from "../Chat.helpers.ts";
import { MessageAck, SvgIcon } from "../chat-list/ChatAvatar.tsx";
import { icons } from "./icons.ts";
import { AudioBubble, DocumentBubble, ImageBubble, StickerBubble, VideoBubble } from "./MediaBubbles.tsx";

type MessageBubbleProps = {
  message: WhatsappMessage;
  chat: WhatsappChat;
  showTail: boolean;
};

export function MessageBubble({ message, chat, showTail }: MessageBubbleProps) {
  const sideClass = message.fromMe ? "wa-bubble-out" : "wa-bubble-in";
  const showSender = !message.fromMe && chat.isGroup && message.senderName;
  const ackStatus = message.fromMe ? persistedOutgoingAckStatus(message.status, message.provider) : message.status;

  return (
    <div className={`wa-bubble ${sideClass} ${showTail ? "wa-bubble-tail" : ""}`}>
      {showTail ? (
        <span className={message.fromMe ? "wa-tail wa-tail-out" : "wa-tail wa-tail-in"}>
          <SvgIcon svg={message.fromMe ? icons.tailOut : icons.tailIn} />
        </span>
      ) : null}
      {showSender ? (
        <div className="wa-bubble-sender" style={{ color: senderColorFor(message.senderJid || message.senderName) }}>
          {message.senderName}
        </div>
      ) : null}
      <MessageBody message={message} />
      <div className="wa-bubble-foot">
        <span className="wa-bubble-time">{fmtTimestamp(message.tsMs)}</span>
        <MessageAck fromMe={message.fromMe} status={ackStatus} />
      </div>
    </div>
  );
}

function MessageBody({ message }: { message: WhatsappMessage }) {
  const kind = effectiveMessageKind(message);
  if (kind === "image") return <ImageBubble message={message} />;
  if (kind === "video" || kind === "gif") return <VideoBubble message={message} />;
  if (kind === "voice" || kind === "audio") return <AudioBubble message={message} />;
  if (kind === "sticker") return <StickerBubble message={message} />;
  if (kind === "document") return <DocumentBubble message={message} />;
  if (kind === "location") return <div className="wa-bubble-media">[local] {message.text || "Localizacao"}</div>;
  if (kind === "contact") return <div className="wa-bubble-media">[contato] {message.text || "Contato"}</div>;
  if (kind === "poll") return <div className="wa-bubble-media">[enquete] {message.text || "Enquete"}</div>;
  if (kind === "reaction") return <div className="wa-bubble-media">[reacao] {message.text || "Reacao"}</div>;
  if (kind === "call") return <div className="wa-bubble-media wa-bubble-system">Chamada</div>;
  if (kind === "unknown") return <div className="wa-bubble-media wa-bubble-system">Mensagem nao suportada</div>;
  return <div className="wa-bubble-text">{message.text || ""}</div>;
}
